import React from 'react';
import HubPage from '../../ui-components/HubPage';

const ITEM_META = {
  '/ai-chat': { icon: 'forum', desc: 'Chat met AI — van strategie tot distributie, met prompts en playbooks per fase' },
  '/gpt-maker': { icon: 'smart_toy', desc: 'Bouw eigen GPT-assistenten voor terugkerende taken' },
  '/inspiration': { icon: 'lightbulb', desc: 'Zoek creatieve referenties en voorbeelden' },
  '/avatar-chat': { icon: 'record_voice_over', desc: 'Praat met een AI-avatar in realtime' },
  '/ai-beelden': { icon: 'auto_awesome', desc: 'Moodframes, stills en korte clips via Higgsfield — met kostenindicatie' },
};

export default function AIHub() {
  return (
    <HubPage
      sectionKey="ai"
      subtitle="Van strategie tot distributie — prompts en tools per fase"
      headerIcon="auto_fix_high"
      itemMeta={ITEM_META}
    />
  );
}
